import { render, staticRenderFns } from "./TransactionalProfileQuestions.vue?vue&type=template&id=c796b3e8&scoped=true"
import script from "./TransactionalProfileQuestions.vue?vue&type=script&lang=js"
export * from "./TransactionalProfileQuestions.vue?vue&type=script&lang=js"
import style0 from "./TransactionalProfileQuestions.vue?vue&type=style&index=0&id=c796b3e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c796b3e8",
  null
  
)

export default component.exports